import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

export const navigateToUrl = async (flowAPI: ControllerFlowAPI, url: string) => {
  const { wixCodeApi } = flowAPI.controllerConfig;

  if (url) {
    wixCodeApi.location.to?.(url);
  }
};
